/**
 * Outreach entry — Campaign Dashboard (API-backed).
 * Kept as default export for existing App.js imports.
 */
import CampaignDashboardPage from "./campaignDashboard/CampaignDashboardPage";

export default CampaignDashboardPage;
